/**
 * Used to store general information about a patient.
 * This information is displayed in the patient snapshot on the "Patient Dashboard" page.
 */

import { Timestamp } from 'firebase/firestore';
import { PatientType } from './patient.model';

export class GeneralInfo {
  /**
   * The type of emergent treatment the patient would or would not receive if their heart or breathing were to stop.
   * Options: Full, Limited, DNR, Comfort Care.
   */
  codeStatus: string;

  /**
   * The patient's date of birth.
   */
  dob: Timestamp;

  /**
   * The patient's age.
   */
  age: number | string;

  /**
   * The patient's sex.
   */
  sex: string;

  /**
   * The patient's weight in kilograms.
   */
  weight: number;

  /**
   * The patient's height in inches.
   */
  heightInches: number;

  /**
   * The patient's isolation status.
   */
  isolation: string;

  /**
   * The type of patient
   */
  patientType: PatientType;

  /**
   * The patient's room number.
   */
  roomNumber: string;

  /**
   * The patient's location.
   */
  location: string;

  constructor() {
    this.codeStatus = '';
    this.dob = Timestamp.now();
    this.age = 0;
    this.sex = '';
    this.weight = 0;
    this.heightInches = 0;
    this.isolation = '';
    this.patientType = 'unassigned';
    this.roomNumber = '';
    this.location = '';
  }
}
